module.exports = __webpack_public_path__ + "images/babb@2x.2d1e1d2f3221cd86bc04d2aba1d57b94.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/logos/babb@2x.png
// module id = 1015
// module chunks = 0